import React from 'react';

const PlatformIcon = () => {
  return (
    <svg className="processing-icon" viewBox="0 0 450 300" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="sky-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#87CEEB" />
          <stop offset="100%" stopColor="#B0E2FF" />
        </linearGradient>
        <linearGradient id="grass-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#7CCD7C" />
          <stop offset="100%" stopColor="#3D9140" />
        </linearGradient>
        <linearGradient id="road-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#A9A9A9" />
          <stop offset="100%" stopColor="#696969" />
        </linearGradient>
        <linearGradient id="mountain-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#A3BCB6" />
          <stop offset="100%" stopColor="#5B7065" />
        </linearGradient>
        <linearGradient id="tree-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#228B22" />
          <stop offset="100%" stopColor="#006400" />
        </linearGradient>
        <linearGradient id="database-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#425b76" />
          <stop offset="100%" stopColor="#2d3e50" />
        </linearGradient>
        <linearGradient id="progress-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#425b76" />
          <stop offset="100%" stopColor="#a0b4c8" />
        </linearGradient>
        <linearGradient id="insights-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3a7bd5" />
          <stop offset="100%" stopColor="#2d3e50" />
        </linearGradient>
        <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>
      
      {/* 1. SCAN - Terrain scene */}
      <g className="terrain">
        {/* Scan section label */}
        <rect x="30" y="25" width="100" height="20" rx="3" fill="#425b76" />
        <text x="80" y="39" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">1. SCAN</text>
        
        {/* Top-down view terrain */}
        <rect x="20" y="50" width="120" height="80" rx="3" fill="#E8F5E9" /> {/* Light green background */}
        
        {/* Lake */}
        <path d="M65,60 C75,58 85,62 90,70 C95,80 90,90 80,95 C70,98 60,95 55,85 C52,75 55,65 65,60 Z" 
              fill="#B3E5FC" stroke="#90CAF9" strokeWidth="1" />
        <path d="M70,68 C72,67 75,69 74,72 C73,74 70,75 68,73 C67,71 68,69 70,68 Z" 
              fill="#E1F5FE" opacity="0.5" />
                
        {/* Main road */}
        <path d="M20,90 L45,90 C55,90 60,75 70,75 C80,75 85,90 95,90 L120,90" 
              stroke="#9E9E9E" strokeWidth="8" fill="none" />
        <path d="M20,90 L45,90 C55,90 60,75 70,75 C80,75 85,90 95,90 L120,90" 
              stroke="#E0E0E0" strokeWidth="1" strokeDasharray="4,2" fill="none" />
        
        {/* Secondary road */}
        <path d="M80,50 L80,75 L80,130" 
              stroke="#9E9E9E" strokeWidth="5" fill="none" />
        <path d="M80,50 L80,130" 
              stroke="#E0E0E0" strokeWidth="1" strokeDasharray="4,2" fill="none" />
        
        {/* Forest clusters */}
        <g>
          {/* Top left forest */}
          <circle cx="35" cy="65" r="5" fill="#2E7D32" opacity="0.8" />
          <circle cx="30" cy="60" r="4" fill="#388E3C" opacity="0.7" />
          <circle cx="40" cy="60" r="4" fill="#388E3C" opacity="0.7" />
          <circle cx="35" cy="55" r="3" fill="#43A047" opacity="0.6" />
          
          {/* Bottom right forest */}
          <circle cx="105" cy="115" r="5" fill="#2E7D32" opacity="0.8" />
          <circle cx="100" cy="110" r="4" fill="#388E3C" opacity="0.7" />
          <circle cx="110" cy="110" r="4" fill="#388E3C" opacity="0.7" />
          <circle cx="105" cy="105" r="3" fill="#43A047" opacity="0.6" />
          
          {/* Bottom left forest */}
          <circle cx="40" cy="115" r="4" fill="#2E7D32" opacity="0.8" />
          <circle cx="35" cy="110" r="3" fill="#388E3C" opacity="0.7" />
          <circle cx="45" cy="110" r="3" fill="#388E3C" opacity="0.7" />
        </g>
        
        {/* Buildings */}
        <rect x="55" y="105" width="8" height="8" fill="#BDBDBD" />
        <rect x="95" y="65" width="10" height="7" fill="#BDBDBD" />
        <rect x="105" y="70" width="5" height="5" fill="#BDBDBD" />
        
        {/* LiDAR scan animation - radial pattern */}
        <g opacity="0.7">
          <circle cx="70" cy="90" r="10" fill="none" stroke="#4682B4" strokeWidth="0.5" strokeDasharray="2,2">
            <animate attributeName="r" from="10" to="60" dur="3s" repeatCount="indefinite" />
            <animate attributeName="opacity" from="0.7" to="0" dur="3s" repeatCount="indefinite" />
          </circle>
          <circle cx="70" cy="90" r="5" fill="none" stroke="#4682B4" strokeWidth="0.5" strokeDasharray="2,2">
            <animate attributeName="r" from="5" to="55" dur="3s" repeatCount="indefinite" begin="1s" />
            <animate attributeName="opacity" from="0.7" to="0" dur="3s" repeatCount="indefinite" begin="1s" />
          </circle>
          <circle cx="70" cy="90" r="0" fill="none" stroke="#4682B4" strokeWidth="0.5" strokeDasharray="2,2">
            <animate attributeName="r" from="0" to="50" dur="3s" repeatCount="indefinite" begin="2s" />
            <animate attributeName="opacity" from="0.7" to="0" dur="3s" repeatCount="indefinite" begin="2s" />
          </circle>
        </g>
        
        {/* LiDAR scan point */}
        <circle cx="70" cy="90" r="2" fill="#FF5722">
          <animate attributeName="opacity" values="0.5;1;0.5" dur="1s" repeatCount="indefinite" />
        </circle>
        
        {/* Upload arrow */}
        <path d="M150,90 L170,90 L170,80 L190,100 L170,120 L170,110 L150,110 Z" fill="#425b76">
          <animate attributeName="opacity" values="0.5;1;0.5" dur="2s" repeatCount="indefinite" />
        </path>
        <text x="170" y="75" textAnchor="middle" fill="#425b76" fontSize="10" fontWeight="bold">UPLOAD</text>
      </g>
      
      {/* 2. PROCESS */}
      <g>
        {/* Process section label */}
        <rect x="200" y="25" width="100" height="20" rx="3" fill="#425b76" />
        <text x="250" y="39" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">2. PROCESS</text>
        
        {/* Processing box */}
        <rect x="200" y="50" width="100" height="80" rx="3" fill="#a0b4c8" opacity="0.2" />
        
        {/* CPU/Processing unit */}
        <rect x="220" y="65" width="60" height="50" rx="3" fill="url(#database-gradient)" />
        
        {/* Progress bars */}
        <rect x="225" y="75" width="50" height="5" rx="2" fill="#f5f5f5" />
        <rect x="225" y="75" width="0" height="5" rx="2" fill="url(#progress-gradient)">
          <animate attributeName="width" from="0" to="50" dur="3s" repeatCount="indefinite" />
        </rect>
        
        <rect x="225" y="85" width="50" height="5" rx="2" fill="#f5f5f5" />
        <rect x="225" y="85" width="0" height="5" rx="2" fill="url(#progress-gradient)">
          <animate attributeName="width" from="0" to="50" dur="2.5s" repeatCount="indefinite" />
        </rect>
        
        <rect x="225" y="95" width="50" height="5" rx="2" fill="#f5f5f5" />
        <rect x="225" y="95" width="0" height="5" rx="2" fill="url(#progress-gradient)">
          <animate attributeName="width" from="0" to="50" dur="2s" repeatCount="indefinite" />
        </rect>
        
        {/* Process to Archive arrow */}
        <path d="M250,140 L250,160 L240,160 L260,180 L280,160 L270,160 L270,140 Z" fill="#425b76">
          <animate attributeName="opacity" values="0.5;1;0.5" dur="2s" repeatCount="indefinite" />
        </path>
      </g>
      
      {/* 3. ARCHIVE */}
      <g>
        {/* Archive section label */}
        <rect x="200" y="185" width="100" height="20" rx="3" fill="#425b76" />
        <text x="250" y="199" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">3. ARCHIVE</text>
        
        {/* Database */}
        <g transform="translate(250, 240)">
          <ellipse cx="0" cy="-20" rx="30" ry="10" fill="url(#database-gradient)" />
          <path d="M-30,-20 L-30,10 C-30,20 -15,30 0,30 C15,30 30,20 30,10 L30,-20" fill="url(#database-gradient)" />
          <ellipse cx="0" cy="10" rx="30" ry="10" fill="none" stroke="#a0b4c8" strokeWidth="0.8" opacity="0.7" />
          <ellipse cx="0" cy="-5" rx="30" ry="10" fill="none" stroke="#a0b4c8" strokeWidth="0.8" opacity="0.7" />
        </g>
        
        {/* Archive to Visualize arrow */}
        <path d="M190,240 L170,240 L170,230 L150,250 L170,270 L170,260 L190,260 Z" fill="#425b76">
          <animate attributeName="opacity" values="0.5;1;0.5" dur="2s" repeatCount="indefinite" />
        </path>
      </g>
      
      {/* 4. VISUALIZE */}
      <g>
        {/* Visualize section label */}
        <rect x="30" y="185" width="100" height="20" rx="3" fill="#425b76" />
        <text x="80" y="199" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">4. VISUALIZE</text>
        
        {/* Screen/Display */}
        <rect x="20" y="210" width="120" height="80" rx="3" fill="#f5f5f5" />
        <rect x="20" y="210" width="120" height="80" rx="3" fill="none" stroke="#425b76" strokeWidth="2" />
        
        {/* 3D visualization */}
        <g transform="translate(30, 220)">
          {/* Background */}
          <rect x="0" y="0" width="100" height="60" fill="#E8F5E9" opacity="0.7" />
          
          {/* Point cloud for the lake */}
          <g fill="#00BFFF">
            <circle cx="40" cy="20" r="1" />
            <circle cx="45" cy="15" r="1" />
            <circle cx="50" cy="20" r="1" />
            <circle cx="55" cy="25" r="1" />
            <circle cx="60" cy="30" r="1" />
            <circle cx="50" cy="30" r="1" />
            <circle cx="45" cy="25" r="1" />
            <circle cx="40" cy="20" r="1" />
          </g>
          
          {/* Point cloud for roads */}
          <g fill="#A0A0A0">
            <circle cx="20" cy="40" r="1" />
            <circle cx="30" cy="40" r="1" />
            <circle cx="40" cy="40" r="1" />
            <circle cx="50" cy="40" r="1" />
            <circle cx="60" cy="40" r="1" />
            <circle cx="70" cy="40" r="1" />
            <circle cx="80" cy="40" r="1" />
            <circle cx="90" cy="40" r="1" />
            <circle cx="50" cy="10" r="1" />
            <circle cx="50" cy="20" r="1" />
            <circle cx="50" cy="30" r="1" />
            <circle cx="50" cy="40" r="1" />
            <circle cx="50" cy="50" r="1" />
          </g>
          
          {/* Point cloud for forest */}
          <g fill="#2E7D32">
            <circle cx="15" cy="15" r="1" />
            <circle cx="17" cy="17" r="1" />
            <circle cx="13" cy="17" r="1" />
            <circle cx="15" cy="13" r="1" />
            <circle cx="80" cy="50" r="1" />
            <circle cx="83" cy="53" r="1" />
            <circle cx="77" cy="53" r="1" />
            <circle cx="80" cy="47" r="1" />
            <circle cx="20" cy="50" r="1" />
            <circle cx="18" cy="52" r="1" />
            <circle cx="22" cy="52" r="1" />
          </g>
          
          {/* Point cloud for buildings */}
          <g fill="#757575">
            <circle cx="35" cy="45" r="1" />
            <circle cx="37" cy="45" r="1" />
            <circle cx="35" cy="47" r="1" />
            <circle cx="37" cy="47" r="1" />
            <circle cx="75" cy="25" r="1" />
            <circle cx="77" cy="25" r="1" />
            <circle cx="79" cy="25" r="1" />
            <circle cx="75" cy="27" r="1" />
            <circle cx="77" cy="27" r="1" />
            <circle cx="79" cy="27" r="1" />
          </g>
        </g>
        
        {/* Visualize to Insights arrow */}
        <path d="M150,240 L170,240 L170,230 L190,250 L170,270 L170,260 L150,260 Z" fill="#425b76" opacity="0" />
      </g>
      
      {/* 5. INSIGHTS */}
      <g>
        {/* Insights section label */}
        <rect x="350" y="185" width="100" height="20" rx="3" fill="#425b76" />
        <text x="400" y="199" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">5. INSIGHTS</text>
        
        {/* Insights visualization */}
        <rect x="355" y="210" width="90" height="80" rx="3" fill="#f5f5f5" />
        
        {/* Charts and graphs */}
        <g transform="translate(365, 220)">
          {/* Bar chart */}
          <rect x="0" y="35" width="10" height="15" fill="url(#insights-gradient)" />
          <rect x="15" y="25" width="10" height="25" fill="url(#insights-gradient)" />
          <rect x="30" y="15" width="10" height="35" fill="url(#insights-gradient)" />
          <rect x="45" y="30" width="10" height="20" fill="url(#insights-gradient)" />
          
          {/* Line chart */}
          <polyline points="0,15 20,5 40,10 60,0 70,5" fill="none" stroke="url(#insights-gradient)" strokeWidth="2" />
          <circle cx="0" cy="15" r="2" fill="url(#insights-gradient)" />
          <circle cx="20" cy="5" r="2" fill="url(#insights-gradient)" />
          <circle cx="40" cy="10" r="2" fill="url(#insights-gradient)" />
          <circle cx="60" cy="0" r="2" fill="url(#insights-gradient)" />
          <circle cx="70" cy="5" r="2" fill="url(#insights-gradient)" />
          
          {/* Annotations */}
          <text x="10" y="60" textAnchor="middle" fill="#425b76" fontSize="5">Data</text>
          <text x="70" y="60" textAnchor="middle" fill="#425b76" fontSize="5">Trends</text>
          <g transform="translate(40, 28)">
            <circle cx="0" cy="0" r="7" fill="#FFCB6B" opacity="0.3" />
            <text x="0" y="2" textAnchor="middle" fill="#425b76" fontSize="6" fontWeight="bold">!</text>
            <animateTransform 
              attributeName="transform" 
              type="scale" 
              values="1;1.2;1" 
              dur="2s" 
              repeatCount="indefinite"
            />
          </g>
        </g>
        
        <rect x="355" y="210" width="90" height="80" rx="3" fill="none" stroke="#425b76" strokeWidth="2" />
      </g>
      
      {/* Connecting flow lines */}
      <path d="M140,250 C160,250 170,250 200,250" stroke="#a0b4c8" strokeWidth="1" strokeDasharray="4,2" opacity="0.6">
        <animate attributeName="stroke-dashoffset" from="24" to="0" dur="4s" repeatCount="indefinite" />
      </path>
      <path d="M300,250 C320,250 340,250 355,250" stroke="#a0b4c8" strokeWidth="1" strokeDasharray="4,2" opacity="0.6">
        <animate attributeName="stroke-dashoffset" from="24" to="0" dur="4s" repeatCount="indefinite" />
      </path>
    </svg>
  );
};

export default PlatformIcon;